import { useContext } from 'react';
import {
  AuthContext,
  AuthContextValue
} from '@/contexts/firebase-auth-context';

export const useAuth = () => useContext(AuthContext) as AuthContextValue;
